/**
 * created by yxy
 * 业务中心路由
 */
import clueView from '../view/clue/clueView'
import Solicitation from '../view/Solicitation/SolicitationView'
export  const  TabRouter =[
    {
        path: "/view/clueView/:key",//pms 线索 view/clueView/clue-Index
        component: clueView
    },
    {
        path: "/view/clueView/contribute/:key", //contribute端 线索 view/clueView/newsClue-contribute-index
        component: clueView
    },
    {
        path: "/view/Solicitation/SolicitationView/:key", //contribute端 线索 view/clueView/newsClue-contribute-index
        component: Solicitation
    },
];

